__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "student-experience-v4-app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(7923), __webpack_require__.e(4158), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(54158))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(4914), __webpack_require__.e(1985), __webpack_require__.e(1479)]).then(() => (() => (__webpack_require__(71479))))));
			register("@mui/material", "6.5.0", () => (Promise.all([__webpack_require__.e(1714), __webpack_require__.e(561), __webpack_require__.e(7923), __webpack_require__.e(1433), __webpack_require__.e(3515), __webpack_require__.e(9036), __webpack_require__.e(4914), __webpack_require__.e(1985), __webpack_require__.e(6672), __webpack_require__.e(4646), __webpack_require__.e(1020)]).then(() => (() => (__webpack_require__(39036))))));
			register("pvs-design-icons", "1.7.0", () => (Promise.all([__webpack_require__.e(7923), __webpack_require__.e(3030), __webpack_require__.e(4914), __webpack_require__.e(1985), __webpack_require__.e(4646), __webpack_require__.e(68)]).then(() => (() => (__webpack_require__(3030))))));
			register("pvs-design-system", "4.10.1", () => (Promise.all([__webpack_require__.e(1714), __webpack_require__.e(561), __webpack_require__.e(7923), __webpack_require__.e(1433), __webpack_require__.e(3515), __webpack_require__.e(5353), __webpack_require__.e(3110), __webpack_require__.e(4914), __webpack_require__.e(1985), __webpack_require__.e(4204), __webpack_require__.e(6672), __webpack_require__.e(4646), __webpack_require__.e(5817), __webpack_require__.e(9180)]).then(() => (() => (__webpack_require__(43110))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-redux", "8.0.5", () => (Promise.all([__webpack_require__.e(9733), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(69733))))));
			register("react-router-dom", "7.18.2", () => (Promise.all([__webpack_require__.e(2886), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(2886))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};